const STORAGE_KEY = "triggered_bco_ids";

export function getTriggeredBcoIds() {
    try {
        const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return Array.isArray(stored) ? stored.filter((id) => typeof id === "string") : [];
    } catch {
        return [];
    }
}

export function rememberTriggeredBco(bcoId) {
    const id = String(bcoId);
    const ids = getTriggeredBcoIds();
    if (!ids.includes(id)) {
        ids.push(id);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    }
}

// Runs that finished or were reset are no longer "triggered this session", so they drop back into
// the already-running list on the next load.
export function pruneTriggeredBcoIds(runningBcoIds) {
    const running = runningBcoIds.map(String);
    const stillRunning = getTriggeredBcoIds().filter((id) => running.includes(id));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stillRunning));
    return stillRunning;
}
